import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import APIS from "../../constant/EndPoint";
//@ts-ignore
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import { useEffect, useState } from "react";
import { getApiData } from "../../helpers/AxiosInstance";
import { createPickupRequestValidationForm } from "../../utils/validationSchemas";
import DriverForm from "../DriverForm";
import Modal from "../Reusable/Modal";
import VehicleForm from "../VehicleForm";
import PickupRequestForm from "./PickupRequestForm";

const CreatePickupRequest = (props: any) => {
  const {
    handleCreate,
    isLoading,
    handleAddVehicle,
    isVehicleLoading,
    handleAddDriver,
    isDriverLoading,
    openAddDriverPopup,
    openAddVehiclePopup,
    setOpenAddDriverPopup,
    setOpenAddVehiclePopup,
  } = props;
  const [senderId, setSenderId] = useState(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    watch,
    control,
    clearErrors,
  } = useForm<any>({
    defaultValues: async () => {
      return {
        order_count: 0,
      };
    },
    resolver: yupResolver(createPickupRequestValidationForm),
  });

  const handleAutoFill = async (id: any) => {
    const url = `${APIS.MERCHANT}${id}/`;
    try {
      const res = await getApiData(url);
      if (res?.status === 200) {
        setValue("sender_primary_contact", res?.data?.user_info?.mobile_number);
        setValue("sender_address", res?.data?.user_info?.address);
      }
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    if (senderId) {
      setValue("merchant", senderId);
      handleAutoFill(senderId);
    }
  }, [senderId]);

  return (
    <>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleCreate}
        setError={setError}
        buttonLabel={"Submit"}
        isLoading={isLoading}
      >
        <PickupRequestForm
          register={register}
          errors={errors}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
          watch={watch}
          control={control}
          setOpenAddDriverPopup={setOpenAddDriverPopup}
          setOpenAddVehiclePopup={setOpenAddVehiclePopup}
          setSenderId={setSenderId}
        />
      </FormLayout>
      <Modal
        isOpen={openAddVehiclePopup}
        setIsOpen={setOpenAddVehiclePopup}
        title={"Add Vehicle"}
        children={
          <>
            <VehicleForm
              register={register}
              errors={errors}
              handleSubmit={handleSubmit}
              handleAddVehicle={handleAddVehicle}
              isVehicleLoading={isVehicleLoading}
            />
          </>
        }
      />
      <Modal
        isOpen={openAddDriverPopup}
        setIsOpen={setOpenAddDriverPopup}
        title={"Add Driver"}
        children={
          <>
            <DriverForm
              register={register}
              errors={errors}
              handleSubmit={handleSubmit}
              setValue={setValue}
              getValues={getValues}
              clearErrors={clearErrors}
              handleAddDriver={handleAddDriver}
              isDriverLoading={isDriverLoading}
            />
          </>
        }
      />
    </>
  );
};

export default CreatePickupRequest;
